(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.bsb-fv').forEach(initSection);
  }

  function initSection(section) {
    if (typeof Swiper === 'undefined') return;

    const el = section.querySelector('.swiper');
    if (!el || el.dataset.bsbFvInitialized) return;
    el.dataset.bsbFvInitialized = 'true';

    const wrap = el.closest('.bsb-fv__carousel-wrap');
    const prevBtn = wrap?.querySelector('[data-swiper-prev]');
    const nextBtn = wrap?.querySelector('[data-swiper-next]');
    const slidesDesktop = parseFloat(section.dataset.slidesDesktop) || 5;
    const slidesMobile = parseFloat(section.dataset.slidesMobile) || 1.5;

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: 14,
      threshold: 5,
      slideToClickedSlide: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        769: {
          slidesPerView: slidesDesktop,
          spaceBetween: 14,
          pagination: { enabled: false }
        }
      },
      grabCursor: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'bsb-fv__arrow--disabled'
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
